import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseBannerModel } from 'app/model/banner/banner';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { BannerService } from 'app/services/banner/banner.service';
import { UserService } from 'app/services/user/user.service';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'act-banner-leaderboard',
  templateUrl: './banner-leaderboard.component.html',
  styleUrls: ['./banner-leaderboard.component.scss']
})
export class BannerLeaderboardComponent implements OnInit, OnDestroy {
  public isMobile;
  public lang;
  public leaderboard: BaseBannerModel;
  public bannerType = 'leaderboard';

  private getBannerLeaderboardSubscription: Subscription;
  private languageSubscription: Subscription;

  constructor(
    private appConfigService: AppConfigService,
    private utilitiesService: UtilitiesService,
    private userService: UserService,
    private bannerService: BannerService,
  ) {
    this.isMobile = this.utilitiesService.isMobile();
    this.lang = this.appConfigService.getLanguage();
  }

  ngOnInit(): void {
    this.fetchLeaderboard();
    this.languageSubscription && this.languageSubscription.unsubscribe();
    this.languageSubscription = this.appConfigService.getLanguageObs()
      .subscribe((val) => {
        if (this.lang !== val) {
          this.lang = val;
          this.fetchLeaderboard();
        }
      });
  }

  ngOnDestroy(): void {
    this.getBannerLeaderboardSubscription && this.getBannerLeaderboardSubscription.unsubscribe();
  }

  fetchLeaderboard(): void {
    const companyId = this.userService.getUser().companyId;
    this.getBannerLeaderboardSubscription && this.getBannerLeaderboardSubscription.unsubscribe();
    this.getBannerLeaderboardSubscription = this.bannerService.getBannerLeaderboard(companyId, this.lang, this.isMobile ? 'mobile' : 'desktop')
      .subscribe((res) => {
        if (res && res.length > 0) {
          this.leaderboard = res[0];
        }
      }, (err) => {
        console.error(err);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/banner-leaderboard/banner-leaderboard.component.ts